/* eslint-disable import/no-cycle */
import { defaultAssignments, defaultRolesAndPermissions } from '@/configs/main';
import {
	setAssignments,
	setRolesAndPermissions,
	setLocalPermissions,
} from '@/helpers/AuthHelper';
import {
	LOGIN_USER_EMBEDDED,
	LOGIN_LOCAL_USER,
	LOGIN_USER,
	LOGIN_USER_SUCCESS,
	LOGIN_USER_ERROR,
	LOGOUT_USER,
	RESET_PASSWORD,
	RESET_PASSWORD_SUCCESS,
	RESET_PASSWORD_ERROR,
	CHANGE_PASSWORD,
	CHANGE_PASSWORD_SUCCESS,
	CHANGE_PASSWORD_ERROR,
	BIND_MOBILE,
	BIND_MOBILE_SUCCESS,
	BIND_MOBILE_ERROR,
	CHANGE_ASSIGNMENTS,
	CHANGE_ROLES_PERMISSIONS,
	LOGIN_USER_SSO,
	LOGIN_USER_SSO2,
	LOGIN_USER_SSO_PSI,
} from '../actions-registry';

export const loginUserEmbedded = (user) => ({
	type: LOGIN_USER_EMBEDDED,
	payload: user,
});
export const loginLocalUser = (user, history, redirectUrl) => ({
	type: LOGIN_LOCAL_USER,
	payload: { user, history, redirectUrl },
});
export const loginUser = (user, history, redirectUrl) => ({
	type: LOGIN_USER,
	payload: { user, history, redirectUrl },
});
export const loginUserSSO = (
	id,
	mid,
	bid,
	type,
	token,
	history,
	redirectUrl
) => ({
	type: LOGIN_USER_SSO,
	payload: { id, mid, bid, type, token, history, redirectUrl },
});
export const loginUserSSOPsi = (mid, bid, token, history, redirectUrl) => ({
	type: LOGIN_USER_SSO_PSI,
	payload: { mid, bid, token, history, redirectUrl },
});
export const loginUserSSO2 = (user) => ({
	type: LOGIN_USER_SSO2,
	payload: user,
});
export const loginUserSuccess = (user) => ({
	type: LOGIN_USER_SUCCESS,
	payload: user,
});
export const loginUserError = (message) => ({
	type: LOGIN_USER_ERROR,
	payload: message,
});
export const logoutUser = (history) => {
	setAssignments(null);
	setRolesAndPermissions(null);
	return {
		type: LOGOUT_USER,
		payload: { history },
	};
};
export const resetPassword = (email, code, password, history) => ({
	type: RESET_PASSWORD,
	payload: { email, code, password, history },
});
export const resetPasswordSuccess = () => ({
	type: RESET_PASSWORD_SUCCESS,
});
export const resetPasswordError = (message) => ({
	type: RESET_PASSWORD_ERROR,
	payload: message,
});
export const changePassword = ({
	oldPassword,
	newPassword,
	history,
	redirectUrl,
	init,
}) => ({
	type: CHANGE_PASSWORD,
	payload: { oldPassword, newPassword, history, redirectUrl, init },
});
export const changePasswordSuccess = (isInit) => ({
	type: CHANGE_PASSWORD_SUCCESS,
	payload: isInit,
});
export const changePasswordError = (message) => ({
	type: CHANGE_PASSWORD_ERROR,
	payload: message,
});
export const bindMobile = (mobile, code, region, history) => ({
	type: BIND_MOBILE,
	payload: { mobile, code, region, history },
});
export const bindMobileSuccess = (mobile) => ({
	type: BIND_MOBILE_SUCCESS,
	payload: mobile,
});
export const bindMobileError = (message) => ({
	type: BIND_MOBILE_ERROR,
	payload: message,
});

export const changeAssignments = (payload) => {
	setAssignments(payload);
	return {
		type: CHANGE_ASSIGNMENTS,
		payload: payload || defaultAssignments,
	};
};
export const changeRolesAndPermissions = (payload) => {
	setRolesAndPermissions(payload);
	return {
		type: CHANGE_ROLES_PERMISSIONS,
		payload: payload || defaultRolesAndPermissions,
	};
};
export const changeLocalPermissions = (payload) => {
	setLocalPermissions(payload);
	return {
		type: CHANGE_ROLES_PERMISSIONS,
		payload: payload || [],
	};
};
